import { CarrierResponse } from '../../../carrier/index';
import { ExcludedCarriersTable } from '../views/excluded-carriers-table';
import { GET_CARRIER_BUSINESS_NAME } from '../../../carrier/utils/get-carrier-business-name';

export const EXCLUDED_CARRIERS_TABLE = (
	carriersResponseList: Array<CarrierResponse> = []
): Array<ExcludedCarriersTable> => {
	let results: Array<ExcludedCarriersTable> = [];
	try {
		if (carriersResponseList.length > 0) {
			carriersResponseList.map((carrier) => {
				let row = {} as ExcludedCarriersTable;
				row.businessName = GET_CARRIER_BUSINESS_NAME(carrier.businessName, carrier.doingBusinessAs);
				row.dot = carrier.dot || '';
				row.excluded = carrier.excluded || false;
				row.mc = carrier.mc || '';
				row.id = carrier.id;
				results.push(row);
			});
		}
	} catch (error) {
		console.log('EXCLUDED_CARRIERS_TABLE error: ', error);
	}

	return results;
};
